import {FilterActions} from '../constants/filter/filter_actions';
import Dispatcher from '../dispatcher';

function setFilter(payload) {
    Dispatcher.handleCatalogFilterProvisionalStateAction({type: FilterActions.SET_PROVISIONAL_FILTER, payload});
}

function setSectionFilter(payload) {
    Dispatcher.handleCatalogFilterProvisionalStateAction({type: FilterActions.SET_PROVISIONAL_SECTION_FILTER, payload});
}

export {
    setFilter,
    setSectionFilter
};